import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=a4b2e2f6&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=a4b2e2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b2e2f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4b2e2f6')) {
      api.createRecord('a4b2e2f6', component.options)
    } else {
      api.reload('a4b2e2f6', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=a4b2e2f6&scoped=true&", function () {
      api.rerender('a4b2e2f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8iB4P35ZhSPWp/JS/comp/DocBox.vue"
export default component.exports